import { render } from "./currentCRMWhatsappInvoicesView.vue?vue&type=template&id=69cad3ce&scoped=true"
import script from "./currentCRMWhatsappInvoicesView.vue?vue&type=script&lang=js"
export * from "./currentCRMWhatsappInvoicesView.vue?vue&type=script&lang=js"

import "./currentCRMWhatsappInvoicesView.vue?vue&type=style&index=0&id=69cad3ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cad3ce"]])

export default __exports__